import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inputUIComponent } from 'ctm-css-themes';
import { applyVerticalStyles } from 'ctm-util-functions';
import { CustomAutoSuggest } from './custom_autosuggest';
import styles from './auto_complete_combo.css';

class SimpleAutoCompleteCombo extends Component {

    constructor() {
        super();
        this.state = {
            suggestions: []
        };
        this.inputUIComponent = applyVerticalStyles(inputUIComponent, 'input');
        this.styles = { ...styles, input: this.inputUIComponent.input_medium };
    }

    /**
     * Gets suggestions based of query string
     * @param {String} value Input query value
     */
    onSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            suggestions: this.getSuggestions(value)
        });
    };

    /**
     * Filters & Returns the array based on the query value
     * @param {String} value Input query value
     * @return {Array} Returns the array of filtered suggestions
     */
    getSuggestions = (value) => {
        const { suggestions } = this.props;
        const inputValue = value.trim().toLowerCase();
        const inputLength = inputValue.length;

        return inputLength === 0 ? suggestions : suggestions.filter((option) => option.label.toLowerCase().includes(inputValue) || option.label.toLowerCase().includes('other'));
    };

    /**
     * Handles the suggestion rendering
     * @param {String} suggestion the suggestion to render
     * @return {Node} Returns the suggestion wrapped in a div
     */
    renderSuggestion = (suggestion) => (<div>{suggestion.label}</div>);

    /**
     * When suggestion is clicked, AutoSuggest populates the input with the returned value
     * @param {String} suggestion the suggestion passed
     * @return {Node} Returns the suggestion label
     */
    getSuggestionValue = (suggestion) => suggestion.label;

    /**
     * AutoSuggest will call this function every time you need to clear suggestions.
     */
    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };

    /**
     * Renders the SimpleAutoCompleteCombo component
     * @return {Node} Returns the SimpleAutoCompleteCombo component
     */
    render() {
        const { placeholder, value, onChange, className, onBlur, ...rest } = this.props;
        const { suggestions } = this.state;
        const optionInputProps = {
            placeholder,
            value,
            onChange,
            onBlur
        };

        return (
            <div className={className} styles={styles.root}>
                <CustomAutoSuggest
                    {...rest}
                    suggestions={suggestions}
                    onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                    onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                    getSuggestionValue={this.getSuggestionValue}
                    shouldRenderSuggestions={() => true}
                    renderSuggestion={this.renderSuggestion}
                    inputProps={optionInputProps}
                    theme={this.styles}
                />
            </div>
        );
    }

}

SimpleAutoCompleteCombo.propTypes = {
    onChange: PropTypes.func.isRequired,
    suggestions: PropTypes.array,
    value: PropTypes.string,
    className: PropTypes.string,
    placeholder: PropTypes.string,
    /**
     * called with the top suggestion when the input loses focus, e.g. when user presses Tab or Enter
     */
    onBlur: PropTypes.func
};

export { SimpleAutoCompleteCombo };
